/**
 * @auth 赖传峰
 * @date 2025/3/20
 * @desc 优先显示分享详情文件，其次当前分享文件
 */
import { computed, inject } from '#imports'
import { InjectionKey } from '~/types/enum'

export default ({
  share,
  shareDetail,
}: {
  share?: ShareRef
  shareDetail?: ShareDetailRef
} = {}) => {
  const share_ = share || inject<ShareRef>(InjectionKey.SHARE)
  const shareDetail_ = shareDetail || inject<ShareDetailRef>(InjectionKey.SHARE_DETAIL)
  return computed<PPFile[]>(() => {
    if (shareDetail_?.value?.files !== undefined) return shareDetail_.value.files
    if (share_?.value?.files !== undefined) return share_.value.files
    return []
  })
}
